// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

export type TextAlignmentOption = DataOption<"left" | "center" | "right">;
export interface TextAlignmentOptionMapper {
    left: TextAlignmentOption;
    center: TextAlignmentOption;
    right: TextAlignmentOption;
}
export type TextAlignmentOptions = DataOptions<TextAlignmentOption> & TextAlignmentOptionMapper;
export type TextAlignment = LiteralUnion<keyof TextAlignmentOptionMapper>;

export const textAlignmentOptions: TextAlignmentOptions = {
    left: { id: "left", displayName: "Left", isDefault: true },
    center: { id: "center", displayName: "Center" },
    right: { id: "right", displayName: "Right" },
};

export type TextAlignmentFieldValue = TextAlignment | undefined;
export interface TextAlignmentFieldOptions {
    isChildDefinition?: boolean;
}

export const getTextAlignmentFieldData = (value: TextAlignmentFieldValue, options?: TextAlignmentFieldOptions) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(textAlignmentOptions, value);
};

export const getTextAlignmentFieldDefinition = (name: string, options?: TextAlignmentFieldOptions) => {
    const { isChildDefinition } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(textAlignmentOptions),
        name,
        displayName: "Text Alignment",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getTextAlignmentField = (name: string, options?: TextAlignmentFieldOptions) => {
    const parse = (value: TextAlignmentFieldValue) => getTextAlignmentFieldData(value, options);
    const parseToFlex = (value: TextAlignmentFieldValue) => {
        if (!value) {
            return undefined;
        }

        switch (value) {
            case textAlignmentOptions.left.id:
                return "flex-start";
            case textAlignmentOptions.center.id:
                return "center";
            case textAlignmentOptions.right.id:
                return "flex-end";
            default:
                return undefined;
        }
    };

    return {
        definition: getTextAlignmentFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
        parseToFlex,
        useParseToFlex: (...parameters: Parameters<typeof parseToFlex>) => {
            return useMemo(() => parseToFlex(...parameters), parameters);
        },
    };
};

export default getTextAlignmentField;
